import React from 'react';
import styled from 'styled-components';
import { Box, get, TextBody } from '@ally/metronome-ui';
import { formattedDate, getMarkerType, getStatus } from '../utils';
import SummaryTrackerMarker from './SummaryTrackerMarker';
import { trackerStatuses, trackerSteps } from '../../constants';
function getStatusContent({ activityName, currentStatus, }) {
    switch (currentStatus) {
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return activityName === 'ACHTransfer' ? 'Processing' : 'Ordered';
        case 'Completed':
        case 'Posted':
            return 'Delivered';
        default:
            return currentStatus;
    }
}
const TrackerStep = styled.li `
  margin: 0;
  padding: 0;
  flex: 1;
  &:first-child {
    ${get.media.down('md')} {
      text-align: left;
    }
  }

  &:first-child,
  &:last-child {
    white-space: initial;
    min-width: 70px;
    ${get.media.down('md')} {
      min-width: initial;
    }
  }

  &:last-child {
    > div::after {
      display: none;
    }
    max-width: 70px;
    ${get.media.down('md')} {
      text-align: right;
      max-width: initial;
    }
  }
`;
const StyledTextBody = styled(TextBody) `
  ${({ status, theme: { colors } }) => `
      ${!status ? `color: ${colors['slate-400']};` : ``}
  `}
`;
function currentStepStatus({ statuses, step, }) {
    return statuses.find(history => {
        if (step === 'Ordered') {
            return trackerStatuses.ordered.includes(history.status);
        }
        return history.status === step;
    });
}
const StepContent = ({ event, currentStatus, markerType, status, step, }) => {
    const hasLabel = markerType !== 'default';
    const { deliverOnDate } = event.eventModelData;
    const isAch = event.activityName === 'ACHTransfer';
    const showDeliverOnDate = isAch && step === 'Completed';
    const isDebit = event.activityName === 'DebitCardOrder';
    const isDebitFailed = isDebit && step === 'Delivery unsuccessful';
    return hasLabel ? (React.createElement(Box, { mt: "xxs", width: markerType === 'start' ? '70px' : 'auto' },
        React.createElement(TextBody, { tag: "div", size: "sm" },
            showDeliverOnDate && !currentStatus && (React.createElement(StyledTextBody, { tag: "p", size: "xs", weight: "bold", status: status },
                "Deliver On",
                React.createElement("br", null),
                formattedDate(deliverOnDate, 'MMM D'))),
            isDebitFailed && (React.createElement(StyledTextBody, { tag: "p", size: "xs", weight: "bold", status: status }, "Delivery unsuccessful")),
            currentStatus && (React.createElement(StyledTextBody, { tag: "p", size: "xs", weight: "bold", status: status },
                getStatusContent({
                    activityName: event.activityName,
                    currentStatus: currentStatus.status,
                }),
                React.createElement("br", null),
                formattedDate(showDeliverOnDate ? deliverOnDate : currentStatus.eventDateTime, 'MMM D')))))) : null;
};
const SummaryTrackerStep = ({ event, isCanceled, stepStatus, step, }) => {
    const { statuses } = event;
    const markerType = getMarkerType({ event, step });
    const currentStatus = currentStepStatus({ statuses, step });
    const firstStepStatus = trackerSteps[event.activityName][0];
    const isFirstStep = step === firstStepStatus;
    const hasProgress = getStatus({
        activityName: event.activityName,
        currentStatus: statuses[0].status,
    }) !== firstStepStatus;
    return (React.createElement(TrackerStep, null,
        !isCanceled && (React.createElement(SummaryTrackerMarker, { markerType: markerType, status: stepStatus, hasHistory: !!currentStatus, isFirstStep: isFirstStep, hasProgress: hasProgress })),
        React.createElement(StepContent, { event: event, currentStatus: currentStatus, markerType: markerType, status: stepStatus, step: step })));
};
export default SummaryTrackerStep;
//# sourceMappingURL=SummaryTrackerStep.js.map